import { Action } from '@ngrx/store';
import { CommunityItem } from 'src/app/models/community-item';

export const CommunityItemAction = {
    AddForceCommunityItemRefresh:
        '[community item] add force community item refresh',
    RemoveForceCommunityItemRefresh:
        '[community item] remove force community item refresh',
    addMyCommunityItem: '[community item] add my community item',
    removeMyCommunityItem: '[community item] remove my community item',
    setMyCommunityItems: '[community item] set my community items',
};

export class AddMyCommunityItem implements Action {
    type = CommunityItemAction.addMyCommunityItem;
    constructor(public item: CommunityItem) {}
}

export class RemoveMyCommunityItem implements Action {
    type = CommunityItemAction.removeMyCommunityItem;
    constructor(public id: string) {}
}

export class SetMyCommunityItems implements Action {
    type = CommunityItemAction.setMyCommunityItems;
    constructor(public items: CommunityItem[]) {}
}

export class AddForceCommunityItemRefresh implements Action {
    type = CommunityItemAction.AddForceCommunityItemRefresh;
    constructor(public communityItemId: string) {}
}

export class RemoveForceCommunityItemRefresh implements Action {
    type = CommunityItemAction.RemoveForceCommunityItemRefresh;
}
